export default {
  route: {
    manufacturers: '成衣生產廠商',    
    rights: '角色權限',    
    coupon: '平臺優惠券',
    images: '客戶的雜圖',
    datainit: '分店初始化數據',
    templatedetails:'系統集成模板詳情',
    sharedimgs: '共享版型圖片',
    orgdetails: '分店詳情',
    productDetails: '版型詳情',
    clothSize: '服裝尺碼',
    platformTitle: '平臺管理',
    platform:{
      platforminfo: '平臺信息',
      accounts: '平臺賬號',
      defaultFunctions:'新店初始權限設置', 
      orgrights:'分店C端機構權限',
      feedback: '客戶反饋',
    },
    ordersTitle: '訂單管理',
    orders: {
      bokesOrder: '電子版訂單',
      clothsOrders: '成衣現貨訂單',
      decorationOders: '飾品訂單',
      fabricsOrder: '面輔料訂單',
      physicalBokes: '紙質版訂單',
      physicalPrinting: '紙質版打印',
      tailoredOrders: '量體訂單',
      tailoredBokes: '來圖版型訂單',
      tailoredCloths: '成衣定製訂單',
      clothsOrder: '成衣現貨訂單',
      tailoredMade: '量體定製版型訂單',
      tailoredMadeDetail:'量體定製訂單詳情',
      videoTeching: '教學課程訂單',
      takeOrders:'成衣接單',
      upgration:'會員升級充值訂單',
      autoscaleOrders:'智能量體訂單'
    },
    customersTitle:'客戶管理',
    customers:{
      customers:'客戶管理',
      levels:'會員等級',
      notes:'平臺優惠券',
      extention:'會員續期審核',
    },
    auditedTitle:'審核管理',
    audited:{
      ref:'版型引用審核',
      shared:'版型共享審核',
      settings:'審核設置',
      fabrics:'面料輔料審核',
      decorations:'服裝飾品審核',
      bokes:'版型成衣審核',
      upShare:'平臺售賣審核'
    },
    productsTitle:'商品管理',
    products: {
      bokes: '版型管理',
      branchProducts:'版型管理',
      cloths: '成衣管理',
      clothDetails: '成衣明細',
      parentSharedprds:'平臺商品',
      upsharedProducts:'分店商品平臺售賣',
      fabrics: '面料管理',
      upshare:'分店上平臺',
      fabricDetails:'面料詳情',
      accessories:'輔料管理',
      decorationDetails:'飾品詳情',
      accessoryDetails:'輔料詳情',
      decoration:'飾品管理',
      sharingFromOther:'分店商品',
      binding:'批量綁定',
      accessoriesDetails:'輔料詳情'
    },
    systemTitle: '系統設置',
    system: {
      clothCategory: '商品類別',
      clothStyle: '服裝風格',
      clothSize: '服裝尺碼',
      productUnit: '商品單位',
      clothSizeViewer: '服裝尺碼詳情',
      videos:'幫助視頻',
      settings:'系統參數設置',
      operationLogs:'操作日誌',
      fabricCategories:'面料分類',
      messages:'全站消息',
      clothSizeTemplate:'尺碼模板管理',
      depositeSettings:'賬戶充值設置',
      course:'製版教學',
      videoCategory:'視頻分類'
    },
    inventoryTitle:'庫存管理',
    inventory:{
      storage:'商品庫存',
      instore:'入庫詳情',
      outstore:'出庫詳情',
    },
    financialTitle:'財務管理',
    financial:{
      recharge:'會員購買記錄',
      myaccount:'資金賬戶',
      accountStatements:'流水記錄',
      withdrawal:'資金提現',
      depositeRecords:'賬戶充值記錄',
      depositeHistories:'賬戶充值設置'
    },
    '新增':'新增','启用':'啟用','禁用':'禁用',
    '您确定要重置该机构的管理员密码吗？':'您確定要重置該機構的管理員密碼嗎？',
    '确认重置':'確認重置','重置密码':'重置密碼',
    '接收':'接收','不收':'不收','不可操作':'不可操作',
    '新增账号':'新增賬號',
    '修改管理员密码':'修改管理員密碼',
    '登录名:':'登錄名:','用户名:':'用戶名:','联系电话:':'聯繫電話:',
    '登录密码:':'登錄密碼:','账户角色:':'賬戶角色:',
    '原始密码:':'原始密碼:','新密码:':'新密碼:','验证码:':'驗證碼:',
    '请录入账号登录名!':'請錄入賬號登錄名!','录入登录名':'錄入登錄名',
    '请录入录入用户名!':'請錄入錄入用戶名!','录入用户名':'錄入用戶名',
    '请录入联系电话!':'請錄入聯繫電話!','录入联系电话':'錄入聯繫電話',
    '请录入录入密码!':'請錄入錄入密碼!','录入密码':'錄入密碼',
    '请选择账户角色!':'請選擇賬戶角色!',
    '请录入原始密码!':'請錄入原始密碼!',
    '请录入短信验证码!':'請錄入短信驗證碼!',
    '获取验证码':'獲取驗證碼',
    '设置成功':'設置成功','发送成功':'發送成功',
    '密码已重置为123456':'密碼已重置為123456',
    '请录入新密码!':'請錄入新密碼!',
    '密码至少6位，且包含字母与数字。':'密碼至少6位，且包含字母與數字。',
    '原始密码不正确。':'原始密碼不正確。','密码修改成功。':'密碼修改成功。',
    '账号添加成功。':'賬號添加成功。','账号添加失败：':'賬號添加失敗：',
    '账号修改成功。':'賬號修改成功。','账号修改失败：':'賬號修改失敗：',
    '版型审核':'版型審核','面料审核':'面料審核','饰品审核':'飾品審核',
    '系统添加':'系統添加','管理员添加':'管理員添加',
    '图标':'圖標','手机号码':'手機號碼',
    '接收订单消息':'接收訂單消息','接收审核消息':'接收審核消息',
    '角色':'角色','账号来源':'賬號來源',
    '创建时间':'創建時間','最后登录时间':'最後登錄時間',
    '秒后重新获取':'秒後重新獲取',
    '登录名、手机号码、用户名':'登錄名、手機號碼、用戶名',
    '雨滴':'雨滴',
    '修改了超级管理员密码':'修改了超級管理員密碼',
    '个人信息':'個人信息','更新图标':'更新圖標','个人资料':'個人資料',
    '登录名':'登錄名','用户名':'用戶名','手机号':'手機號','登录时间':'登錄時間',
    '所属机构':'所屬機構','机构类型':'機構類型','编辑个人信息':'編輯個人信息',
    '请输入昵称!':'請輸入暱稱!','请输入手机号!':'請輸入手機號!',
    '所属机构:':'所屬機構:','保存更改':'保存更改','机构信息':'機構信息',
    'LOGO白:':'LOGO白:','LOGO黑:':'LOGO黑:','客服链接:':'客服鏈接:',
    '机构全称:':'機構全稱:','请输入机构全称!':'請輸入機構全稱!',
    '网站地址:':'網站地址:','机构简称:':'機構簡稱:','请输入机构简称!':'請輸入機構簡稱!',
    '营业执照号:':'營業執照號:','请输入营业执照号!':'請輸入營業執照號!',
    '营业执照:':'營業執照:','机构所在地:':'機構所在地:','请输入机构所在地!':'請輸入機構所在地!',
    '机构责任人:':'機構責任人:','请输入机构责任人!':'請輸入機構責任人!',
    '责任人电话:':'責任人電話:','请输入责任人电话!':'請輸入責任人電話!',
    '责任人证件号:':'責任人證件號:','请输入责任人身份证号!':'請輸入責任人身份證號!',
    '注册类型:':'註冊類型:','微信子商户号:':'微信子商戶號:','微信APPID:':'微信APPID:',
    '您确定要删除该配置吗，删除后将会影响系统正常支付？':'您確定要刪除該配置嗎，刪除後將會影響系統正常支付？',
    '未配置':'未配置','扫码绑定打单员':'掃碼綁定打單員',
    '首页设置':'首頁設置','首页标题:':'首頁標題:','请输入首页标题!':'請輸入首頁標題!',
    '首页描述:':'首頁描述:','请输入首页描述!':'請輸入首頁描述!',
    '首页图片:':'首頁圖片:','绑定发货物流':'綁定發貨物流',
    '绑定新物流公司':'綁定新物流公司','微信支付':'微信支付',
    '分账账户':'分賬賬戶','开通微信支付':'開通微信支付',
    '请输入微信子商户号!':'請輸入微信子商戶號!','请输入微信APPID!':'請輸入微信APPID!',
    '绑定物流公司':'綁定物流公司','物流公司:':'物流公司:','请选择物流公司!':'請選擇物流公司!',
    '请选择物流公司':'請選擇物流公司','物流账号:':'物流賬號:','请录入物流账号!':'請錄入物流賬號!',
    '请录入物流账号':'請錄入物流賬號','绑定密码:':'綁定密碼:',
    '绑定失败：':'綁定失敗：',
    '解除绑定失败：':'解除綁定失敗：','解除绑定成功':'解除綁定成功',
    '代码':'代碼','附加码':'附加碼','添加时间':'添加時間',
    '域名已存在':'域名已存在',
    '图片尺寸太小，不符合要求，至少50*50，且长宽比为1:1':'圖片尺寸太小，不符合要求，至少50*50，且長寬比為1:1',
    '图片尺寸太大，不符合要求，宽高不能超过800*800，且长宽比为1:1':'圖片尺寸太大，不符合要求，寬高不能超過800*800，且長寬比為1:1',
    '编辑个人账户信息':'編輯個人賬戶信息','保存失败，手机号码可能已使用！':'保存失敗，手機號碼可能已使用！',
    '请录入正确的域名地址，不包含http/https,例demo':'請錄入正確的域名地址，不包含http/https,例demo',
    '更新成功':'更新成功','更新失败，请稍后再次尝试。':'更新失敗，請稍後再次嘗試。',
    'LOGO图片不符合要求,请重新选择。':'LOGO圖片不符合要求,請重新選擇。',
    '编辑机构信息':'編輯機構信息','保存成功':'保存成功',
    '企业':'企業','个人':'個人',
    '请输入客户姓名、手机号码开始查询':'請輸入客戶姓名、手機號碼開始查詢','客户类别':'客戶類別',
    '会员级别':'會員級別','导出号码':'導出號碼','个':'個',
    '新增会员':'新增會員','会员昵称:':'會員暱稱:','请录入会员昵称!':'請錄入會員暱稱!',
    '密码:':'密碼:','如不输入，密码默认123456':'如不輸入，密碼默認123456',
    '手机号码:':'手機號碼:','会员等级:':'會員等級:','会员长度':'會員長度','会员长度:':'會員長度:',
    '会员续期':'會員續期','续期长度:':'續期長度:','请选择续期长度!':'請選擇續期長度!',
    '一个月':'一個月','三个月':'三個月','六个月':'六個月','一年':'一年','两年':'兩年','三年':'三年',
    '自定义':'自定義','续期长度':'續期長度','到期时间:':'到期時間:','请选择到期截止时间!':'請選擇到期截止時間!',
    '续期方式:':'續期方式:','请选择续期方式!':'請選擇續期方式!',
    '对公汇款购买升级':'對公匯款購買升級','会员延期':'會員延期','其它':'其它','续期方式':'續期方式',
    '备注:':'備註:','续期备注':'續期備註','手动续期':'手動續期',
    '续版数量:':'續版數量:','请录入续版数量!':'請錄入續版數量!',
    '支付金额:':'支付金額:','支付金额!':'支付金額!','续期时长:':'續期時長:','请选择续期长度':'請選擇續期長度',
    '截止时间:':'截止時間:','请录入过期结止时间!':'請錄入過期結止時間!',
    '手动延期':'手動延期','对公转账':'對公轉賬','线下转账':'線下轉賬',
    '您确定要删除这个客户吗？删除后不可恢复！':'您確定要刪除這個客戶嗎？刪除後不可恢復！',
    '发券':'發券','退卡':'退卡','你确定要':'你確定要','该账号吗？':'該賬號嗎？',
    '你确定要重置该账号密码吗？默认密码为123456':'你確定要重置該賬號密碼嗎？默認密碼為123456',
    '会员备注':'會員備註','更新备注':'更新備註','会员续期记录':'會員續期記錄',
    '序号':'序號','时长':'時長','续期时间':'續期時間','操作员':'操作員',
    '个月':'個月','驳回:':'駁回:','续期通过':'續期通過','待支付':'待支付','天':'天',
    '您确定将当前账号解除黑名单吗？':'您確定將當前賬號解除黑名單嗎？',
    '您确定将当前账号拉入黑名单吗？':'您確定將當前賬號拉入黑名單嗎？',
    '充值':'充值','消费':'消費','退费':'退費',
    '变更会员级别':'變更會員級別','请选择一个会员级别!':'請選擇一個會員級別!',
    '从一般会员升级为会员，过期日期为当天，请及时为会员续期。':'從一般會員升級為會員，過期日期為當天，請及時為會員續期。',
    '储值账户退款':'儲值賬戶退款','账户本金':'賬戶本金','请录入退款金额!':'請錄入退款金額!',
    '剩余赠额':'剩餘贈額','已用赠额':'已用贈額','实退金额':'實退金額',
    '退款说明':'退款說明','请录入退款说明!':'請錄入退款說明!','确定退卡':'確定退卡',
    '下载限制':'下載限制','单日下载限制:':'單日下載限制:','单日最大下载限制数量!':'單日最大下載限制數量!',
    '失效日期:':'失效日期:','请录入失效日期!':'請錄入失效日期!',
    '失效时间:':'失效時間:','请录入失效时间!':'請錄入失效時間!','说明':'說明',
    '1、限制会员单日下载电子版型数量。':'1、限制會員單日下載電子版型數量。',
    '2、为0，此设置不限制。':'2、為0，此設置不限制。',
    '3、不为0且在有限时间内，会限制。':'3、不為0且在有限時間內，會限制。',
    '4、该限制优先于全局限制。':'4、該限制優先於全侷限制。',
    '发放优惠券':'發放優惠券','券名称:':'券名稱:',
    '普通会员':'普通會員','3个月':'3個月','6个月':'6個月','12个月':'12個月','终身':'終身',
    '客户充值/消费明细':'客戶充值/消費明細','订单号':'訂單號','充值金额':'充值金額',
    '赠送金额':'贈送金額','充值时间':'充值時間','类型':'類型',
    '下载余量':'下載餘量','账户余额':'賬戶餘額','会员过期时间':'會員過期時間',
    '过期天数':'過期天數','备注':'備註','黑名单':'黑名單',
    '1个月':'1個月','2个月':'2個月','半年':'半年','二年':'二年','四年':'四年','五年':'五年',
    '未过期':'未過期','已过期':'已過期','30天内过期':'30天內過期','已禁用':'已禁用','储值用户':'儲值用戶',
    '实退金额不能小于0!':'實退金額不能小於0!',
    '发放成功':'發放成功','当前客户不符合该券的发放要求，发放失败！':'當前客戶不符合該券的發放要求，發放失敗！',
    '请选择需要发放的优惠券！':'請選擇需要發放的優惠券！','备注更新成功':'備註更新成功',
    '本金':'本金','已使用赠额':'已使用贈額','实退':'實退',
    '退卡成功':'退卡成功','其它会员':'其它會員',
    '新增客户:':'新增客戶:','客户新增成功':'客戶新增成功',
    '账号：':'賬號：','的密码':'的密碼','重置密码成功！':'重置密碼成功！',
    '当前客户有未完成的会员续期单据，请完成后再发起续期。':'當前客戶有未完成的會員續期單據，請完成後再發起續期。',
    '续期成功':'續期成功','续期会员':'續期會員','的有效期':'的有效期',
    '设置账号的下载限制':'設置賬號的下載限制',
    '最后登录时间倒序':'最後登錄時間倒序','会员过期时间倒序':'會員過期時間倒序','会员创建时间倒序':'會員創建時間倒序',
    '面料折扣': '面料折扣',
    '购买时长': '購買時長',
    '购买金额': '購買金額',
    '店主购买金额': '店主購買金額',
    '所衣折扣': '所衣折扣',
    '饰品折扣': '飾品折扣',
    '辅料折扣': '輔料折扣',
    '可下载数量': '可下載數量',
    '等级名称': '等級名稱',
    '成衣定制折扣': '成衣定製折扣',
    '成衣现货折扣': '成衣現貨折扣',
    '版型下载数量': '版型下載數量',
    '购买时长(月)': '購買時長(月)',
    '终端客户购买金额': '終端客戶購買金額',
    '编辑会员等级': '編輯會員等級',
    '的数据': '的數據',
    '保存成功！': '保存成功！',
    '优惠券设置': '優惠券設置',
    '请录入券名称!': '請錄入券名稱!',
    '请录入券名称，如双十一活动券。': '請錄入券名稱，如雙十一活動券。',
    '券类型:': '券類型:',
    '请选择券类型!': '請選擇券類型!',
    '推荐用户券': '推薦用戶券',
    '活动券': '活動券',
    '用户券': '用戶券',
    '核销对象:': '核銷對象:',
    '请录入核销对象!': '請錄入核銷對象!',
    '受众范围:': '受眾範圍:',
    '请录入受众范围!': '請錄入受眾範圍!',
    '使用门槛:': '使用門檻:',
    '请录入使用门槛!': '請錄入使用門檻!',
    '请录入券的最低使用门槛金额。': '請錄入券的最低使用門檻金額。',
    '券面金额:': '券面金額:',
    '请录入券面金额!': '請錄入券面金額!',
    '请录入券面金额。': '請錄入券面金額。',
    '券有效期:': '券有效期:',
    '请录入券有效时间范围!': '請錄入券有效時間範圍!',
    '开始日期': '開始日期',
    '结束日期': '結束日期',
    '所有券清单': '所有券清單',
    '停用': '停用',
    '设置': '設置',
    '确定要删除当前券吗，删除后不可恢复？': '確定要刪除當前券嗎，刪除後不可恢復？',
    '券已过期': '券已過期',
    '消费金额超过': '消費金額超過',
    '已发券清单': '已發券清單',
    '发放券': '發放券',
    '未设': '未設',
    '最近一个月未登录': '最近一個月未登錄',
    '最近两个月未登录': '最近兩個月未登錄',
    '最近三个月未登录': '最近三個月未登錄',
    '半年未登录': '半年未登錄',
    '最近一个月未下单': '最近一個月未下單',
    '最近两个月未下单': '最近兩個月未下單',
    '最近三个月未下单': '最近三個月未下單',
    '半年未下单': '半年未下單',
    '会员数:': '會員數:',
    '不重复发放': '不重複發放',
    '券名称': '券名稱',
    '发放': '發放',
    '定向生效': '定向生效',
    '生效周期': '生效週期',
    '券面金额': '券面金額',
    '受众范围': '受眾範圍',
    '使用门槛': '使用門檻',
    '开始时间': '開始時間',
    '截止时间': '截止時間',
    '过期时间': '過期時間',
    '累计订单': '累計訂單',
    '最后下单时间': '最後下單時間',
    '客户': '客戶',
    '来源': '來源',
    '发放类型': '發放類型',
    '发生时间': '發生時間',
    '新增优惠券': '新增優惠券',
    '券类型': '券類型',
    '导出': '導出',
    '订单列表': '訂單列表',
    '支付宝支付': '支付寶支付',
    '线下支付': '線下支付',
    '余额支付': '餘額支付',
    '退款': '退款',
    '确定要作废这个订单吗？': '確定要作廢這個訂單嗎？',
    '作废': '作廢',
    '客户分组': '客戶分組',
    '订单详情': '訂單詳情',
    '客户信息': '客戶信息',
    '客户姓名': '客戶姓名',
    '联系电话': '聯繫電話',
    '下单时间': '下單時間',
    '版型号': '版型號',
    '数量': '數量',
    '订单金额': '訂單金額',
    '券抵扣': '券抵扣',
    '版型退款': '版型退款',
    '退款人': '退款人',
    '退款时间': '退款時間',
    '留言': '留言',
    '购买尺码': '購買尺碼',
    '尺码数据': '尺碼數據',
    '电话': '電話',
    '商品名称': '商品名稱',
    '附件': '附件',
    '尺码': '尺碼',
    '评分': '評分',
    '店面信息': '店面信息',
    '订单数量': '訂單數量',
    '门店信息': '門店信息',
    '电子版型订单': '電子版型訂單',
    '的订单': '的訂單',
    '复制成功': '複製成功',
    '无': '無',
    '订单作废成功！': '訂單作廢成功！',
    '管理员版型退款': '管理員版型退款',
    '退款成功': '退款成功',
    '全部': '全部',
    '客户姓名/手机号/订单号': '客戶姓名/手機號/訂單號',
    '请输入编码、系统编码、版型标题查询': '請輸入編碼、系統編碼、版型標題查詢',
  '服装类别': '服裝類別',
  '版型/定制': '版型/定製',
  '添加版型': '添加版型',
  '版型列表': '版型列表',
  '版型共享': '版型共享',
  '全选': '全選',

  '点击开通成衣量体定制': '點擊開通成衣量體定製',

  '点击修改量体定制价格': '點擊修改量體定製價格',
  '下载版型': '下載版型',
  '所有面料饰品': '所有面料飾品',
  '没有绑定面料或饰品': '沒有綁定面料或飾品',
  '面料饰品': '面料飾品',
  '制版师机构列表': '製版師機構列表',
  '提交': '提交',
  '颜色：': '顏色：',
  '成衣定制上下架': '成衣定製上下架',
  '恢复': '恢復',
  '已删除': '已刪除',
  '面料名称': '面料名稱',
  '面料名称：': '面料名稱：',
  '请录入面料名称!': '請錄入面料名稱!',
  '请引用面料  →': '請引用面料  →',
  '引用面料': '引用面料',
  '面料颜色：': '面料顏色：',
  '请引用面料': '請引用面料',
  '面料款号：': '面料款號：',
  '请录入面料款号!': '請錄入面料款號!',
  '成衣定制标题：': '成衣定製標題：',
  '请录入成衣成衣定制标题!': '請錄入成衣成衣定製標題!',
  '成衣生产加工费：': '成衣生產加工費：',
  '客户定制成衣价：': '客戶定製成衣價：',
  '会员定制成衣价：': '會員定製成衣價：',
  '成衣定制说明：': '成衣定製說明：',
  '请录入成衣描述!': '請錄入成衣描述!',
  '请在此录入成衣定制描述': '請在此錄入成衣定製描述',
  '新增面料': '新增面料',
  '版型组套': '版型組套',
  '请输入版型标题，代码进行检索': '請輸入版型標題，代碼進行檢索',
  '版型类别': '版型類別',
  '审核还未开始，暂无数据。': '審核還未開始，暫無數據。',
  '版型浏览': '版型瀏覽',
  '版型基本信息': '版型基本信息',
  '版型标题': '版型標題',
  '版型款号': '版型款號',
  '版型价格': '版型價格',
  '服装分类': '服裝分類',
  '版型描述': '版型描述',
  '成衣描述': '成衣描述',
  '版型图片': '版型圖片',
  '版型文件': '版型文件',
  '面料信息': '面料信息',
  '面料': '面料',
  '配饰信息': '配飾信息',
  '配饰': '配飾',
  '流程浏览': '流程瀏覽',
  '电子版型': '電子版型',
  '绑定': '綁定',
  '恢复成功': '恢復成功',
  '开通成功！': '開通成功！',
  '只有开通了成衣定制了才能上下架产品。': '只有開通了成衣定製了才能上下架產品。',
  '账号已停用或绑定错误。': '賬號已停用或綁定錯誤。',
  '提交共享成功': '提交共享成功',
  '新面料': '新面料',
  '饰品名称:': '飾品名稱:',
  '请录入饰品名称!': '請錄入飾品名稱!',
  '饰品颜色:': '飾品顏色:',
  '请录入饰品颜色!': '請錄入飾品顏色!',
  '饰品款号:': '飾品款號:',
  '请录入饰品款号!': '請錄入飾品款號!',
  '饰品类别:': '飾品類別:',
  '请选择饰品类别!': '請選擇飾品類別!',
  '成本价格:': '成本價格:',
  '请录入商品成本价格!': '請錄入商品成本價格!',
  '分销价格:': '分銷價格:',
  '请录入商品分销价格!': '請錄入商品分銷價格!',
  '销售价格:': '銷售價格:',
  '请录入商品销售价格!': '請錄入商品銷售價格!',
  '会员价格:': '會員價格:',
  '请录入商品会员价格!': '請錄入商品會員價格!',
  '销售单位:': '銷售單位:',
  '请录入销售单位!': '請錄入銷售單位!',
  '商品描述:': '商品描述:',
  '请录入商品描述!': '請錄入商品描述!',
  '请在此录入商品描述': '請在此錄入商品描述',
  '单击选择': '單擊選擇',
  '一个或多个文件上传': '一個或多個文件上傳',
  '上传的文件将按文件扩展自动分类': '上傳的文件將按文件擴展自動分類',
  '图片文件': '圖片文件',
  '商品信息': '商品信息',
  '保存': '保存',
  '审核受理中，不可编辑': '審核受理中，不可編輯',
  '已审核,不可编辑': '已審核,不可編輯',
  '保存并提交审核': '保存並提交審核',
  '解除审核': '解除審核',
  '撤销审核申请': '撤銷審核申請',
  '返回': '返回',
  '解锁成功': '解鎖成功',
  '撤销成功': '撤銷成功',
  '撤销失败,当前状态不能被撤销。': '撤銷失敗,當前狀態不能被撤銷。',
  '当前账号没有该权限，请联系管理理员': '當前賬號沒有該權限，請聯繫管理理員',
  '图片删除成功': '圖片刪除成功',
  '审核通过。': '審核通過。',
  '提交成功': '提交成功',
  '饰品新增成功': '飾品新增成功',
  '饰品保存成功': '飾品保存成功',
  '请输入编码、系统编码、饰品标题查询': '請輸入編碼、系統編碼、飾品標題查詢',
  '商品共享': '商品共享',
  '共享': '共享',
  '不共享': '不共享',
  '饰品范围': '飾品範圍',
  '所有饰品': '所有飾品',
  '上级饰品': '上級飾品',
  '本店饰品': '本店飾品',
  '批量上下架': '批量上下架',
  '查询': '查詢',
  '添加饰品': '添加飾品',
  '缩图': '縮圖',
  '平台编号': '平臺編號',
  '款号': '款號',
  '状态': '狀態',
  '标题': '標題',
  '颜色': '顏色',
  '库存数': '庫存數',
  '销售价': '銷售價',
  '所属门店': '所屬門店',
  '上下架时间': '上下架時間',
  '最后修改人': '最後修改人',
  '操作': '操作',
  '修改上架时间': '修改上架時間',
  '确定': '確定',
  '取消': '取消',
  '待审核': '待審核',
  '已审核': '已審核',
  '已驳回': '已駁回',
  '审核中': '審核中',
  '上架平台': '上架平臺',
  '未通过': '未通過',
  '下架平台': '下架平臺',
  '上架': '上架',
  '下架': '下架',
  '编辑': '編輯',
  '查看': '查看',
  '删除': '刪除',
  '加颜色': '加顏色',
  '设为头版': '設為頭版',
  '添加饰品颜色': '添加飾品顏色',
  '饰品标题:': '飾品標題:',
  '请录入饰品标题!': '請錄入飾品標題!',
  '饰品编号:': '飾品編號:',
  '饰品单位:': '飾品單位:',
  '请录入PLT文件价格!': '請錄入PLT文件價格!',
  '请录入成本价格!': '請錄入成本價格!',
  '请录入销售价格!': '請錄入銷售價格!',
  '确定删除该图片吗？': '確定刪除該圖片嗎？',
  '请选择需要添加的版型。': '請選擇需要添加的版型。',
  '审核详情': '審核詳情',
  '审核尚未开始': '審核尚未開始',
  '不通过': '不通過',
  '通过': '通過',
  '原因：': '原因：',
  '审核附件': '審核附件',
  '关闭': '關閉',
  '引用': '引用',
  '标题：': '標題：',
  '请录入版型标题：!': '請錄入版型標題：!',
  '销售价：': '銷售價：',
  '会员价：': '會員價：',
  '分销价：': '分銷價：',
  '版型说明：': '版型說明：',
  '请在入版型描述!': '請在入版型描述!',
  '请在此录入版型描述': '請在此錄入版型描述',
  '更新': '更新',
  '删除商品': '刪除商品',
  '您确认删除该商品吗？删除后不可恢复！！': '您確認刪除該商品嗎？刪除後不可恢復！！',
  '请勾选需要批量上下架的产品': '請勾選需要批量上下架的產品',
  '上级店面的商品': '上級店面的商品',
  '自已创建的商品': '自已創建的商品',
  '批量上架': '批量上架',
  '批量下架': '批量下架',
  '删除成功！': '刪除成功！',
  '设置封面成功。': '設置封面成功。',
  '操作成功': '操作成功',
  '面料标题:': '面料標題:',
  '请录入面料标题!': '請錄入面料標題!',
  '面料颜色:': '面料顏色:',
  '请录入面料颜色!': '請錄入面料顏色!',
  '面料编号:': '面料編號:',
  '面料单位:': '面料單位:',
  '请输入编码、系统编码、成衣标题查询': '請輸入編碼、系統編碼、成衣標題查詢',
  '面料范围': '面料範圍',
  '所有面料': '所有面料',
  '上级面料': '上級面料',
  '本店面料': '本店面料',
  '添加面料': '添加面料',
  '创建组套': '創建組套',
  '保存组套': '保存組套',
  '取消组套': '取消組套',
  '绑定成衣': '綁定成衣',
  '添加面料颜色': '添加面料顏色',
  '输入关键字查询成衣': '輸入關鍵字查詢成衣',
  '编号': '編號',
  '上架时间': '上架時間',
  '成衣组套': '成衣組套',
  '输入编号标题开始查询': '輸入編號標題開始查詢',
  '选择': '選擇',
  '确认组套': '確認組套',
  '宽度': '寬度',
  '米': '米',
  '解套': '解套',
  '组套': '組套',
  '确认绑定': '確認綁定',
  '下一步': '下一步',
  '上一步': '上一步',
  '删除成功': '刪除成功',
  '共享成功': '共享成功',
  '取消共享成功': '取消共享成功',
  '设置成功。': '設置成功。',
  '版型更新成功': '版型更新成功',
  '面料新增成功': '面料新增成功',
  '请录入正确的价格!': '請錄入正確的價格!',
  '元': '元',
  '博克CAD-PLT-尺码文件': '博克CAD-PLT-尺碼文件',
  '打包下载': '打包下載',
  '版型信息': '版型信息',
  '绑定面料': '綁定面料',
  '绑定配饰': '綁定配飾',
  '上传的EXCEL尺码与所选择的尺码类型不匹配': '上傳的EXCEL尺碼與所選擇的尺碼類型不匹配',
  '尺码匹配错误': '尺碼匹配錯誤',
  '缺失': '缺失',
  '忽略': '忽略',
  '正在下载文件中，请稍后……': '正在下載文件中，請稍後……',
  '尺码更新成功': '尺碼更新成功',
  '当前账号没有编辑权限，请联系管理员。': '當前賬號沒有編輯權限，請聯繫管理員。',
  '文件删除成功': '文件刪除成功',
  '已存在，不能重复添加': '已存在，不能重複添加',
  '上传失败': '上傳失敗',
  '尺码数据匹配错误，请修改后再保存！': '尺碼數據匹配錯誤，請修改後再保存！',
  '版型新增成功': '版型新增成功',
  '版型保存成功': '版型保存成功',
  '版型保存失败': '版型保存失敗',
  '面料商:': '面料商:',
  '运单信息:': '運單信息:',
  '运单号:': '運單號:',
  '服装标题:': '服裝標題:',
  '请录入服装标题!': '請錄入服裝標題!',
  '服装款号:': '服裝款號:',
  '请录入服装编号!': '請錄入服裝編號!',
  'PLT文件价格:': 'PLT文件價格:',
  '版型分销价格:': '版型分銷價格:',
  '服装风格:': '服裝風格:',
  '服装分类:': '服裝分類:',
  '尺码类型:': '尺碼類型:',
  '请选择尺码表类别': '請選擇尺碼錶類別',
  '适应季节:': '適應季節:',
  '春': '春',
  '夏': '夏',
  '秋': '秋',
  '冬': '冬',
  '版型调整视频:': '版型調整視頻:',
  '上传视频': '上傳視頻',
  '浏览视频': '瀏覽視頻',
  '动态短视频:': '動態短視頻:',
  '请录入动态短视频!': '請錄入動態短視頻!',
  '版型描述:': '版型描述:',
  '请录入录入版型描述!': '請錄入錄入版型描述!',
  '查看视频': '查看視頻',
  '上下架': '上下架',
  '是否共享': '是否共享',
  '平台售卖': '平臺售賣',
  '服装版型': '服裝版型',
  '成衣定制': '成衣定製',
  '该产品处于上架中，不可删除！': '該產品處於上架中，不可刪除！',
  '该产品处于共享中，不可删除！': '該產品處於共享中，不可刪除！',
  '请先删除子项！': '請先刪除子項！',
  '只有审核通过的产品才能上架产品。': '只有審核通過的產品才能上架產品。',
  '该产品已停止共享，暂不可上架！': '該產品已停止共享，暫不可上架！',
  '原店面已将该产品下架，暂不可上架！': '原店面已將該產品下架，暫不可上架！',
  '上架成功！': '上架成功！',
  '下架成功！': '下架成功！',
  '平台上架提交成功。': '平臺上架提交成功。',
  '平台上架取消成功。': '平臺上架取消成功。',
  '已完成{0}个产品的上架操作。': '已完成{0}個產品的上架操作。',
  '已完成{0}个产品的下架操作。': '已完成{0}個產品的下架操作。',
  '成组成功': '成組成功',
  '请至少勾选两个项目进行组套！': '請至少勾選兩個項目進行組套！',
  '取消成组成功。': '取消成組成功。',
  '解套成功。': '解套成功。',
  '绑定成功': '綁定成功',
  '当前版型已经绑定了其它成衣，不再能再次绑定了。': '當前版型已經綁定了其它成衣，不再能再次綁定了。',
  '绑定失败': '綁定失敗',
  '解绑成功': '解綁成功',
  '分类': '分類',
  '图片': '圖片',
  'PLT价': 'PLT價',
  'BOKE价': 'BOKE價',
  '客户取货方式': '客戶取貨方式',
    '邮寄': '郵寄',
    '收货地址': '收貨地址',
    '顺丰ID': '順豐ID',
    '物流信息': '物流信息',
    '物流公司': '物流公司',
    '发货': '發貨',
    '收货人': '收貨人',
    '收货人电话': '收貨人電話',
    '联系方式': '聯繫方式',
    '售后订单': '售後訂單',
    '预售订单': '預售訂單',
    '详情': '詳情',
    '处理': '處理',
    '待接收订单': '待接收訂單',
    '已接收订单': '已接收訂單',
    '手动派单': '手動派單',
    '平台版师': '平臺版師',
    '入驻版师': '入駐版師',
    '支付时间': '支付時間',
    '商品退款': '商品退款',
    '邮寄费用': '郵寄費用',
    '退邮寄费': '退郵寄費',
    '券减免': '券減免',
    '售后事项': '售後事項',
    '退款商品': '退款商品',
    '货物状态': '貨物狀態',
    '退款原因': '退款原因',
    '退款金额': '退款金額',
    '相关图片': '相關圖片',
    '同意退款': '同意退款',
    '拒绝退款': '拒絕退款',
    '签收货物': '簽收貨物',
    '确认签收': '確認簽收',
    '确认退款': '確認退款',
    '确定要作废这个订单吗': '確定要作廢這個訂單嗎',
    '视频安装': '視頻安裝',
    '安装时间': '安裝時間',
    '安装人': '安裝人',
    '安装状态': '安裝狀態',
    '安装备注': '安裝備註',
    '请选择安装时间': '請選擇安裝時間',
    '请选择安装人': '請選擇安裝人',
    '请选择安装状态': '請選擇安裝狀態',
    '课程退款': '課程退款',
    '课程名称': '課程名稱',
    '支付并开通': '支付並開通',
    '修改价格': '修改價格',
    '原始订单金额': '原始訂單金額',
    '新订单金额': '新訂單金額',
    '已开通': '已開通',
    '已提交': '已提交',
    '已支付': '已支付',
    '已作废': '已作廢',
    '刷新': '刷新',
    '当前没有未派送的订单': '當前沒有未派送的訂單',
    '成衣图片': '成衣圖片',
    '客户体型': '客戶體型',
    '暂无客户体型图片': '暫無客戶體型圖片',
    '饰品信息': '飾品信息',
    '抢单': '搶單',
    '自动匹配': '自動匹配',
    '撤销更改': '撤銷更改',
    '保存量体尺码': '保存量體尺碼',
    '正在下载文件中请稍后': '正在下載文件中，請稍後……',
    '加载中': '加載中……',
    '下载当前客户版型': '下載當前客戶版型',
    '下载团体客户版型': '下載團體客戶版型',
    '产品标题': '產品標題',
    '下载': '下載',
    '成衣型号': '成衣型號',
    '售后状态': '售後狀態',
    '订单状态': '訂單狀態',
    '退款发起日期': '退款發起日期',
    '货运信息': '貨運信息',
    '面料号': '面料號',
    '饰品号': '飾品號',
    '我的订单': '我的訂單',
    '专属版型': '專屬版型',
    '新增订单': '新增訂單',
    '纸质版型': '紙質版型',
    '线下量体': '線下量體',
    '下载团体客户数据': '下載團體客戶數據',
    '面料订单': '面料訂單',
    '辅料订单': '輔料訂單',
    '账户支付': '賬戶支付',
    '已取件': '已取件',
    '运输中': '運輸中',
    '已签收': '已簽收',
    '已发货': '已發貨',
    '待发货': '待發貨',
    '多状态': '多狀態',
    '运单号': '運單號',
    '送至': '送至',
    '设置顺丰ID': '設置順豐ID',
    '请录入顺丰ID': '請錄入順豐ID',
    '邮费': '郵費',
    '打印费': '打印費',
    '退打印费': '退打印費',
    '已完成打印': '完成打印',
    '已打印': '已打印',
    '打印': '打印',
    '订单已发货': '訂單已發貨！',
    '版型已打印': '版型已打印！',
    '未收到货': '未收到貨',
    '已收到货': '已收到貨',
    '不想要了': '不想要了',
    '协商一致退款': '協商一致退款',
    '空包裹': '空包裹',
    '快递一直未送到': '快遞一直未送到',
    '商品破损已拒签': '商品破損已拒籤',
    '客户申请退货退款': '客戶申請退貨退款',
    '买家退货': '買家退貨',
    '退款完毕': '退款完畢',
    '客户寄回货物': '客戶寄回貨物',
    '商家同意退货': '商家同意退貨',
    '等待接收退货说明': '等待接收客戶退回的貨物，收到貨後確認簽收即可完成退款。',
    '商家拒绝退货': '商家拒絕退貨',
    '拒绝原因': '拒絕原因',
    '回复时间': '回覆時間',
    '商家已退款': '商家已退款',
    '退款成功时间': '退款成功時間',
    '请录入拒绝原因': '請錄入拒絕原因',
    '确认签收并退款': '確認簽收並退款',
    '确认签收提示': '您確認收到退回貨物了嗎，點擊確認後將向客戶退回貨款',
    '确认退款提示': '當前訂單未發貨，將退回總金額',
    '您确认退款吗': '您確認退款嗎？',
    '收件人': '收件人：',
    '收件人电话': '收件人電話：',
    '收件地址': '收件地址：',
    '物流信息标签': '物流信息：',
    '原订单号': '原訂單號：',
    '商品货号': '商品貨號：',
    '退款失败': '退款失敗',
    '全部门店': '全部門店',
    '自营平台': '自營平臺',
    '重置': '重置',
    '批次号': '批次號',
    '量体类型': '量體類型',
    '下载个人': '下載個人',
    '下载团体': '下載團體',
    '打印清单': '打印清單',
    '收件人标签': '收件人',
    '联系电话标签': '聯繫電話',
    '收件地址标签': '收件地址',
    '购买版型': '購買版型',
    '购买尺码标签': '購買尺碼',
    '微信扫码查看小程序': '微信掃碼查看小程序',
    '微信扫码联系客服': '微信掃碼聯繫客服',
    '微信扫码查看细节': '微信掃碼查看細節',
    '面料生产提示': '因不同屬性面料料性差別大，為保證成品效果，請選擇相似\\相近面料生產成衣。',
    '电话标签': '電話',
    '网址': '網址',
    '总接单': '總接單:',
    '今接单': '今接單:',
    '总': '總',
    '今': '今',
    '请选择需要回复的信息': '請選擇需要回復的信息',
    '输入消息内容': '輸入消息內容',
    '请输入金额': '請輸入金額',
    '发送': '發送',
    '出价': '出價',
    '咨询': '諮詢',
    '企微': '企微',
    '结束': '結束',
    '是否继续': '當前操作會關閉當前售後訂單，是否繼續？',
    '是': '是',
    '否': '否',
    '订单已确认等待付款': '訂單已確認，等待客戶付款。',
    '订单已付款等待发布': '訂單已付款，等待版師發佈版型。',
    '请选择待派送订单': '請選擇待派送訂單！',
    '请输入物流单号': '請輸入物流單號',
    '定制图片': '定製圖片',
    '定制尺码': '定製尺碼',
    '上传附件': '上傳附件',
    '请将BOKE文件打包上传': '請將BOKE文件+尺碼文件+PLT文件打包上傳',
    '购买版型按钮': '購買版型',
    '线下预约量体': '線下預約量體',
    '面料商': '面料商',
    '金额': '金額',
    '公司': '公司',
    '生产商': '生產商',
    '成衣生产商': '成衣生產商',
    '输入生产商': '輸入生產商',
    '总接单数': '總接單數:',
    '今日接单': '今日接單:',
    '待发货标签': '待發貨',
    '到店自取': '到店自取',
    '物流': '物流：',
    '单号': '單號：',
    '查看详情': '查看詳情',
    '接收订单': '接收訂單',
    '确定要撤回这个订单吗': '確定要撤回這個訂單嗎？',
    '撤回': '撤回',
    '加工费/生产商': '加工費/生產商',
    '订单来源': '訂單來源',
    '订单信息': '訂單信息',
    '版型类型': '版型類型',
    '价格': '價格',
    '总金额': '總金額',
    '名称': '名稱',
    '在线下载': '在線下載',
    '相同地址合并发货': '相同地址合併發貨',
    '联系地址': '聯繫地址',
    '点击查看详情': '點擊查看詳情',
    '点击上传版型': '點擊上傳版型',
    '点击删除已上传的版型文件': '點擊刪除已上傳的版型文件',
    '点击下载订单文件': '點擊下載訂單文件',
    '已退款': '已退款',
    '版型费': '版型費',
    '纸质版型订单': '紙質版型訂單',
    '快递商': '快遞商',
    '打印清单提示': '打印清單',
    '请输入需要下载的内容': '正在下載文件中，請稍後……',
    '开通成功提示': '開通成功，請通知會員退出重新登錄後生效',
    '请选择需要开通的会员订单': '請選擇需要開通的會員訂單',
    '该订单已支付不能修改': '該訂單已支付，不能修改',
    '修改成功': '修改成功',
    '订单已分配提示': '訂單已分配生產商，無需重複分配',
    '您已成功接单': '您已成功接單',
    '订单未付款不能发货': '訂單未付款，不能發貨',
    '订单已退款不能发货': '訂單已退款，不能發貨',
    '订单已作废不能发货': '訂單已作廢，不能發貨',
    '请填写物流信息': '請填寫物流信息',
    '订单已发货提示': '訂單已發貨',
    '正在下载文件中': '正在下載文件中，請稍後……',
    '售后退款': '售後退款',
    '退回': '退回',
    '生产商统一提供': '生產商統一提供',
    '请输入生产商': '輸入生產商',
    '客户姓名手机号订单号': '客戶姓名/手機號/訂單號',
    '智能量体订单': '智能量體訂單',
    '匹配范围': '匹配範圍',
    '运费': '運費',
    '成衣预售订单': '成衣預售訂單',
    '缺少收件人信息': '缺少收件人信息',
    '订单作废成功': '訂單作廢成功！',
    '请选择是否同意退款': '請選擇是否同意退款！',
    '售后退款标签': '售後退款',
    '后台退款备注': '後臺退款，備註：',
    '成衣现货订单': '成衣現貨訂單',
    '高震服装设计': '高震服裝設計',
    '分店': '分店',
    '饰品退款': '飾品退款',
    '邮寄费': '郵寄費',
    '设计师': '設計師',
    '接单时间': '接單時間',
    '发起时间': '發起時間',
    '服务时间': '服務時間',
    '加码订单号': '加碼訂單號',
    '点击复制': '點擊複製',
    '点击下载': '點擊下載',
    '未打印': '未打印',
    '回复内容不能为空': '回覆內容不能為空！',
    '没有发现售后订单': '沒有發現售後訂單',
    '派单成功': '派單成功！',
    '该机构当日接单数量已超限': '該機構當日接單數量已超限，不能再接單了。',
    '账号已停用或绑定错误': '賬號已停用或綁定錯誤。',
    '请设置发货人信息': '請設置發貨人信息',
    '上传成功': '上傳成功',
    '的订单已发货': '的訂單已發貨！',
    '饰品订单': '飾品訂單',
    '量体定制订单': '量體定製訂單',
    '输入': '輸入',
    '自动匹配，匹配范围：': '自動匹配，匹配範圍：',
    '已退款标签': '已退款',
    '退款商品:': '退款商品:',
    '货物状态:': '貨物狀態:',
    '退款原因:': '退款原因:',
    '退款金额:': '退款金額:',
    '退款说明:': '退款說明:',
    '相关图片:': '相關圖片:',
    '会员开通支付订单': '會員開通支付訂單',
    '支付金额': '支付金額',
    '操作人': '操作人',
    '订单时间': '訂單時間',
    '操作时间': '操作時間',
    '订单类别': '訂單類別',
    '优惠金额': '優惠金額',
    '客户名称': '客戶名稱',
    '升级级别': '升級級別',
    '级别周期': '級別週期',
    '级别结束时间': '級別結束時間',
    '可下载次数': '可下載次數',
    '平台金额': '平臺金額',
    '待向平台支付并开通会员': '待向平臺支付並開通會員',
    '价格修改记录': '價格修改記錄',
    '修改人': '修改人',
    '修改时间': '修改時間',
    '会员下单': '會員下單',
    '会员升级充值订单': '會員升級充值訂單',
    '级别开始时间': '級別開始時間',
    '】码新增成功': '】碼新增成功',
    
    一键引用: '一鍵引用',
    
    上平台: '上平臺',
    上平台售卖审核: '上平臺售賣審核',
    
    上级成衣: '上級成衣',
    上级版型: '上級版型',
    上级辅料: '上級輔料',
    
    '个产品的上架操作。': '個產品的上架操作。',
    '个产品的下架操作。': '個產品的下架操作。',
    二级分店: '二級分店',
    '二级分店:': '二級分店:',
    产品类别: '產品類別',
    会员价: '會員價',
    '会员价:': '會員價:',
    会员价格: '會員價格',
    
    供应商列表: '供應商列表',
    
    保存绑定: '保存綁定',
    
    修改为: '修改為',
    修改密码: '修改密碼',
    修改成衣量体定制价格: '修改成衣量體定製價格',
    修改成衣颜色: '修改成衣顏色',
    修改订单价格: '修改訂單價格',
    修改记录: '修改記錄',
    
    全不选: '全不選',
    
    分店上下架: '分店上下架',
    分店代码: '分店代碼',
    分店分销至其它分店: '分店分銷至其它分店',
    分店名称: '分店名稱',
    
    分销价: '分銷價',
    分销价格: '分銷價格',
    
    分销数: '分銷數',
    
    删除引用: '刪除引用',
    
    加码: '加碼',
    
    单位: '單位',
    
    博克文件价格: '博克文件價格',
    原价: '原價',
    
    原始密码: '原始密碼',
    
    原订单价格: '原訂單價格',
    
    品牌名称: '品牌名稱',
    商品价格: '商品價格',
    
    商品分类: '商品分類',
    商品图片: '商品圖片',
    商品基本信息: '商品基本信息',
    商品描述: '商品描述',
    
    商品标题: '商品標題',
    商品款号: '商品款號',
    商品类别: '商品類別',
    商品详情: '商品詳情',
    
    审核不通过: '審核不通過',
    
    '审核人：': '審核人：',
    审核受理中不可编辑: '審核受理中不可編輯',
    
    审核时间: '審核時間',
    审核结果: '審核結果',
    审核记录: '審核記錄',
    
    审核通过: '審核通過',
    
    小程序APPID: '小程序APPID',
    小程序Secret: '小程序Secret',
    
    尺码类型: '尺碼類型',
    
    '尺码表类别:': '尺碼錶類別:',
    
    已完成: '已完成',
    
    已审核不可编辑: '已審核不可編輯',
    已引用: '已引用',
    已绑定面料: '已綁定面料',
    
    平台成衣: '平臺成衣',
    平台版型库: '平臺版型庫',
    
    平台辅料: '平臺輔料',
    平台面料: '平臺面料',
    平台饰品: '平臺飾品',
    
    开启预售: '開啟預售',
    '开启预售:': '開啟預售:',
    开放时间: '開放時間',
    开通: '開通',
    
    开通成衣量体定制: '開通成衣量體定製',
    开通指引: '開通指引',
    
    待确认: '待確認',
    微信支付公钥ID: '微信支付公鑰ID',
    微信支付公钥文件: '微信支付公鑰文件',
    微信支付参数获取指引: '微信支付參數獲取指引',
    微信支付商户ID: '微信支付商戶ID',
    微信支付密钥: '微信支付密鑰',
    微信支付证书: '微信支付證書',
    微信支付证书号: '微信支付證書號',
    微信服务号APPID: '微信服務號APPID',
    
    成本价: '成本價',
    成本价格: '成本價格',
    
    成衣: '成衣',
    '成衣【': '成衣【',
    成衣信息: '成衣信息',
    
    '成衣描述:': '成衣描述:',
    成衣标题: '成衣標題',
    成衣款号: '成衣款號',
    成衣添加尺码: '成衣添加尺碼',
    
    '成衣生产成本价：': '成衣生產成本價：',
    
    成衣范围: '成衣範圍',
    成衣预售: '成衣預售',
    
    所有成衣: '所有成衣',
    所有版型: '所有版型',
    所有辅料: '所有輔料',
    
    扫码绑定成功: '掃碼綁定成功',
    
    批量引用平台版型: '批量引用平臺版型',
    指导价: '指導價',
    
    改价: '改價',
    
    文件大小不能超过2M: '文件大小不能超過2M',
    
    新密码: '新密碼',
    
    无法修改价格: '無法修改價格',
    时间: '時間',
    
    '是否上架:': '是否上架:',
    
    '是否共享给平台:': '是否共享給平臺:',
    是否引用: '是否引用',
    昵称: '暱稱',
    暂无面料: '暫無面料',
    暂无饰品: '暫無飾品',
    
    '最晚发货时间:': '最晚發貨時間:',
    最晚发货时间不能早于预售时间: '最晚發貨時間不能早於預售時間',
    
    服装定制: '服裝定製',
    服装尺码: '服裝尺碼',
    '服装尺码:': '服裝尺碼:',
    服装标题: '服裝標題',
    
    服装编号: '服裝編號',
    '服装编号:': '服裝編號:',
    '服装配饰:': '服裝配飾:',
    '服装面料:': '服裝面料:',
    '服装颜色:': '服裝顏色:',
    服装风格: '服裝風格',
    
    '服装饰品:': '服裝飾品:',
    未引用: '未引用',
    
    本店成衣: '本店成衣',
    本店版型: '本店版型',
    本店辅料: '本店輔料',
    
    来源门店: '來源門店',
    
    正在生成二维码: '正在生成二維碼',
    
    浏览: '瀏覽',
    
    添加: '添加',
    添加二级分销分店: '添加二級分銷分店',
    添加分店: '添加分店',
    添加成衣: '添加成衣',
    添加成衣颜色: '添加成衣顏色',
    
    添加辅料: '添加輔料',
    添加辅料颜色: '添加輔料顏色',
    
    点击确定开始引用平台产品: '點擊確定開始引用平臺產品',
    版型: '版型',
    
    版型上架: '版型上架',
    版型上架时间: '版型上架時間',
    
    版型分销价格: '版型分銷價格',
    
    版型定制: '版型定製',
    
    '生产尺码:': '生產尺碼:',
    '生产面料:': '生產面料:',
    申请时间: '申請時間',
    申请详情: '申請詳情',
    申请门店: '申請門店',
    
    登录账号: '登錄賬號',
    
    确定引用: '確定引用',
    确认删除该引用吗: '確認刪除該引用嗎',
    '确认删除该引用吗，一旦删除产品将会自动下架，相关订单也会受到影响，确认删除吗？': '確認刪除該引用嗎，一旦刪除產品將會自動下架，相關訂單也會受到影響，確認刪除嗎？',
    确认并上架: '確認並上架',
    
    绑定公众号: '綁定公眾號',
    绑定公众号接收消息提醒: '綁定公眾號接收消息提醒',
    
    绑定微信公众号: '綁定微信公眾號',
    
    绑定成衣数: '綁定成衣數',
    绑定版型: '綁定版型',
 
    绑定饰品: '綁定飾品',
    '结果：': '結果：',

    订单状态为: '訂單狀態為',

    设置封面: '設置封面',

 
    '该成衣所有尺码均已添加，无需再加码。': '該成衣所有尺碼均已添加，無需再加碼。',
    '请勾选成衣尺码!': '請勾選成衣尺碼!',
    请在此录入成衣描述: '請在此錄入成衣描述',
    请在此录入辅料描述: '請在此錄入輔料描述',
    请在此录入面料描述: '請在此錄入面料描述',
    请录入会员价格: '請錄入會員價格',
    '请录入会员价格!': '請錄入會員價格!',
    请录入分销价格: '請錄入分銷價格',
    '请录入分销价格!': '請錄入分銷價格!',
    请录入制作价格: '請錄入製作價格',
    '请录入制作价格!': '請錄入製作價格!',
    请录入原始密码: '請錄入原始密碼',
    请录入商户ID: '請錄入商戶ID',
    请录入微信支付密钥: '請錄入微信支付密鑰',
    请录入成本价格: '請錄入成本價格',
    请录入成衣款号: '請錄入成衣款號',
    请录入最晚发货时间: '請錄入最晚發貨時間',
    请录入服务号APPID: '請錄入服務號APPID',
    请录入服装分类: '請錄入服裝分類',
    '请录入服装分类!': '請錄入服裝分類!',
    请录入服装尺码: '請錄入服裝尺碼',
    请录入服装标题: '請錄入服裝標題',
    '请录入服装颜色!': '請錄入服裝顏色!',
    请录入服装风格: '請錄入服裝風格',
    请录入证书: '請錄入證書',
    请录入辅料会员价格: '請錄入輔料會員價格',
    请录入辅料分销价格: '請錄入輔料分銷價格',
    请录入辅料名称: '請錄入輔料名稱',
    请录入辅料成本价格: '請錄入輔料成本價格',
    请录入辅料描述: '請錄入輔料描述',
    '请录入辅料标题!': '請錄入輔料標題!',
    请录入辅料款号: '請錄入輔料款號',
    请录入辅料销售价格: '請錄入輔料銷售價格',
    '请录入辅料颜色!': '請錄入輔料顏色!',
    请录入销售单位: '請錄入銷售單位',
    请录入面料会员价格: '請錄入面料會員價格',
    请录入面料分类: '請錄入面料分類',
    请录入面料分销价格: '請錄入面料分銷價格',
    请录入面料单位: '請錄入面料單位',
    请录入面料名称: '請錄入面料名稱',
    请录入面料宽度: '請錄入面料寬度',
    请录入面料成本价格: '請錄入面料成本價格',
    请录入面料描述: '請錄入面料描述',

    请录入面料款号: '請錄入面料款號',
    请录入面料销售价格: '請錄入面料銷售價格',
    请录入面料颜色: '請錄入面料顏色',
    请录入预售时间: '請錄入預售時間',
    '请确认是否上架!': '請確認是否上架!',
    '请确认是否共享给平台!': '請確認是否共享給平臺!',
    
    请输入款号标题查询: '請輸入款號標題查詢',
    
    '请输入编码、系统编码、辅料标题查询': '請輸入編碼、系統編碼、輔料標題查詢',
    
    请输入编码系统编码成衣标题查询: '請輸入編碼系統編碼成衣標題查詢',
    请输入编码系统编码标题查询: '請輸入編碼系統編碼標題查詢',
    请输入编码系统编码版型标题查询: '請輸入編碼系統編碼版型標題查詢',
    '请选择二级分店!': '請選擇二級分店!',
    请选择商品类别: '請選擇商品類別',
    
    '请选择服装分类!': '請選擇服裝分類!',
    请选择需要批量引用的服装类别: '請選擇需要批量引用的服裝類別',
    
    请选择面料分类: '請選擇面料分類',
    
    账号信息: '賬號信息',
    
    购买: '購買',
    辅料上架: '輔料上架',
    辅料信息: '輔料信息',
    '辅料单位:': '輔料單位:',
    辅料名称: '輔料名稱',
    辅料平台上架: '輔料平臺上架',
    辅料描述: '輔料描述',
    辅料新增成功: '輔料新增成功',
    '辅料标题:': '輔料標題:',
    辅料款号: '輔料款號',
    辅料添加颜色: '輔料添加顏色',
    '辅料编号:': '輔料編號:',
    辅料范围: '輔料範圍',
    辅料颜色: '輔料顏色',
    '辅料颜色:': '輔料顏色:',    
    输入关键字查询版型: '輸入關鍵字查詢版型',    
    输入面料商开始筛选: '輸入面料商開始篩選',    
    退出登录: '退出登錄',
    适应季节: '適應季節',    
    选择门店: '選擇門店',    
    销售价格: '銷售價格',    
    销售单位: '銷售單位',
    
    销量: '銷量',
    门店: '門店',
    零售价: '零售價',
    
    面料下架: '面料下架',
    
    面料分类: '面料分類',
    面料列表: '面料列表',
    面料单位: '面料單位',
    面料宽度: '面料寬度',
    面料描述: '面料描述',
    
    面料查询: '面料查詢',
    面料标题: '面料標題',
    
    面料款号: '面料款號',
    
    面料颜色: '面料顏色',
    '订单数':'訂單數',
    预估用量: '預估用量',
    预售: '預售',
    预售成衣: '預售成衣',
    '预售时间:': '預售時間:',
    
    风格: '風格',
    
    饰品列表: '飾品列表',
    
    饰品商: '飾品商',    
    饰品查询: '飾品查詢',
    开始: '開始',
    添加结点: '添加結點',
    面辅料审核: '面輔料審核',
    共享审核: '共享審核',
    合规性审核: '合規性審核',
    更新审核设置: '更新審核設置',
    审核状态: '審核狀態',
    版型成衣选择: '版型成衣選擇',

    审核: '審核',
    申请单号: '申請單號',
    申请事项: '申請事項',

    制作价格: '製作價格',
    原因: '原因',
    请录入审核不通过的原因: '請錄入審核不通過的原因',
    请选择审核结果: '請選擇審核結果',
    审核成功: '審核成功',
    您当前没有待审核的共享版型: '您當前沒有待審核的共享版型。',
    您当前没有待审核的面辅料: '您當前沒有待審核的面輔料。',
    您当前没有待审核的饰品: '您當前沒有待審核的飾品。',
    您当前没有待审核的引用版型: '您當前沒有待審核的引用版型。',
    辅料: '輔料',
    面辅料选择: '面輔料選擇',
    基本信息: '基本信息',
    产品编号: '產品編號',
    产品描述: '產品描述',
    面料图片: '面料圖片',
    饰品基本信息: '飾品基本信息',
    饰品标题: '飾品標題',
    饰品编号: '飾品編號',
    饰品描述: '飾品描述',
    饰品图片: '飾品圖片',
    下发门店: '下發門店',
    尺码行数: '尺碼行數',
    发布时间: '發佈時間',
    智能版型: '智能版型',
    提交时间: '提交時間',
    成衣尺码: '成衣尺碼',
    自营: '自營',
    蓝迪云平台: '藍迪雲平臺',
    引用审核: '引用審核',
    您当前没有待审核的:'您當前沒有待審核的',
    面辅料:'面輔料',
    '未审核': '未審核',
    '已拒绝': '已拒絕',
    '驳回': '駁回',
    '请选择审核结果!': '請選擇審核結果!',
    '驳回原因': '駁回原因',
    '请输入驳回原因': '請輸入駁回原因',
    '续期开始时间': '續期開始時間',
    '续期结束时间': '續期結束時間',
    '会员续期审核': '會員續期審核',
    '收入类别': '收入類別',
    '会员编号': '會員編號',
    '收入金额': '收入金額',
    '收入项目': '收入項目',
    '项目代码': '項目代碼',
    '可用': '可用',
    '新增账户充值信息': '新增賬戶充值信息',
    '录入充值金额': '錄入充值金額',
    '录入说明详情': '錄入說明詳情',
    '新增成功': '新增成功',
    '客户姓名/手机号': '客戶姓名/手機號',
    '总本金金额': '總本金金額',
    '总赠送金额': '總贈送金額',
    '续费周期': '續費週期',
    '付款方式': '付款方式',
    '微信': '微信',
    '支付宝': '支付寶',
    '提现': '提現',
    '待提现': '待提現',
    '已完结': '已完結',
    '执行提现': '執行提現',
    '提现收款账号': '提現收款賬號',
    '提现金额': '提現金額',
    '提现申请人': '提現申請人',
    '提现申请时间': '提現申請時間',
    '执行人': '執行人',
    '执行时间': '執行時間',
    '提现状态': '提現狀態',
    '执行': '執行',
    '提现账号': '提現賬號',
    '开户行': '開戶行',
    '账号名称': '賬號名稱',
    '银行卡号': '銀行卡號',
    '提现额度': '提現額度',
    '请线下将钱款打入对方账号后，再进行此操作。': '請線下將錢款打入對方賬號後，再進行此操作。',
    '打款完成': '打款完成',
    '提现执地成功': '提現執地成功',
    '全部商品': '全部商品',
    '饰品': '飾品',
    '入库编号': '入庫編號',
    '单价': '單價',
    '商品类型': '商品類型',
    '入库数量': '入庫數量',
    '最新库存数量': '最新庫存數量',
    '入库原因': '入庫原因',
    '新进货入库': '新進貨入庫',
    '盘盈入库': '盤盈入庫',
    '其他入库': '其他入庫',
    '出库编号': '出庫編號',
    '出库数量': '出庫數量',
    '出库原因': '出庫原因',
    '出库时间': '出庫時間',
    '销售出库': '銷售出庫',
    '盘亏出库': '盤虧出庫',
    '损耗出库': '損耗出庫',
    '出库': '出庫',
    '入库': '入庫',
    '出入记录': '出入記錄',
    '未上架': '未上架',
    '已上架': '已上架',
    '出入库详情': '出入庫詳情',
    '手动出库': '手動出庫',
    '当前库存数': '當前庫存數',
    '输入出库数量': '輸入出庫數量',
    '选择出库原因': '選擇出庫原因',
    '添加库存': '添加庫存',
    '新入库数量': '新入庫數量',
    '输入入库数量': '輸入入庫數量',
    '选择入库原因': '選擇入庫原因',
    '其它入库': '其它入庫',
    '请输入出库原因！': '請輸入出庫原因！',
    '请输入出库数量': '請輸入出庫數量',
    '请输入入库原因！': '請輸入入庫原因！',
    '请输入入库数量': '請輸入入庫數量',
    '入库成功': '入庫成功',
    '单价(元)': '單價(元)',
    '出入数量': '出入數量',
    '当前数量': '當前數量',
    '操作类型': '操作類型',
    '操作人员': '操作人員',
    '是否启用': '是否啟用',
    '站内通知': '站內通知',
    '请录入站内通知!': '請錄入站內通知!',
    '站内通知：一行为一条，轮询通知。': '站內通知：一行為一條，輪詢通知。',
    '新增类别': '新增類別',
    '辅料分类': '輔料分類',
    '饰品分类': '飾品分類',
    '确定要删除这个项目吗？': '確定要刪除這個項目嗎？',
    '确定删除': '確定刪除',
    '添加子项': '添加子項',
    '使用中': '使用中',
    '父编码': '父編碼',
    '录入父编码': '錄入父編碼',
    '类型名称': '類型名稱',
    '录入类型名称': '錄入類型名稱',
    '排序码': '排序碼',
    '录入排序码': '錄入排序碼',
    '父编号': '父編號',
    '关联数量': '關聯數量',
    '最近修改时间': '最近修改時間',
    '新增尺码': '新增尺碼',
    '模板名称': '模板名稱',
    '蓝迪云尺码': '藍迪雲尺碼',
    '加盟商尺码': '加盟商尺碼',
    '保留尺码': '保留尺碼',
    '被使用数': '被使用數',
    '绑定数量': '綁定數量',
    '关联大类': '關聯大類',
    '用途分类': '用途分類',
    '创建人': '創建人',
    '新增分组': '新增分組',
    '导入': '導入',
    '尺码名称': '尺碼名稱',
    '录入类型简码': '錄入類型簡碼',
    '尺码类别': '尺碼類別',
    '尺码分组': '尺碼分組',
    '请录入尺码关联大类': '請錄入尺碼關聯大類',
    '版型系统': '版型系統',
    '量体系统': '量體系統',
    '成衣系统': '成衣系統',
    '系统尺码': '系統尺碼',
    '自定义尺码': '自定義尺碼',
    '尺码删除成功': '尺碼刪除成功',
    '删除成功。': '刪除成功。',
    '新增成功。': '新增成功。',
    '请选择关联尺码大类。': '請選擇關聯尺碼大類。',
    '尺码新增成功。': '尺碼新增成功。',
    '尺码编辑成功。': '尺碼編輯成功。',
    '新增服装类别': '新增服裝類別',
    '尺码详情': '尺碼詳情',
    '只显示定制需要参数': '只顯示定製需要參數',
    '仅显示命名尺码(新规格不显示)': '僅顯示命名尺碼(新規格不顯示)',
    '保存参数': '保存參數',
    '全新导入': '全新導入',
    '另存为模板': '另存為模板',
    '导入模板': '導入模板',
    '参数设置': '參數設置',
    '必要': '必要',
    '主要': '主要',
    '次要': '次要',
    '占位': '佔位',
    '没有尺码数据': '沒有尺碼數據',
    '主次要': '主次要',
    '模板名称：': '模板名稱：',
    '给当前模板命个名吧': '給當前模板命個名吧',
    '模板导入发生错误！': '模板導入發生錯誤！',
    '模板名称已存在！': '模板名稱已存在！',
    '导入成功': '導入成功',
    '尺码重新导入成功。': '尺碼重新導入成功。',
    '尺码保存成功。': '尺碼保存成功。',
    '新增服装风格': '新增服裝風格',
    '风格名称': '風格名稱',
    '简码': '簡碼',
    '引用数': '引用數',
    '确定删除吗': '確定刪除嗎',
    '新增课程': '新增課程',
    '课程封面': '課程封面',
    '课程级别': '課程級別',
    '课程价格': '課程價格',
    '课程长度': '課程長度',
    '请录入课程名称!': '請錄入課程名稱!',
    '初级': '初級',
    '中级': '中級',
    '高级': '高級',
    '请选择课程级别!': '請選擇課程級別!',
    '课程时长': '課程時長',
    '请录入课程时长!': '請錄入課程時長!',
    '小时': '小時',
    '请录入课程价格!': '請錄入課程價格!',
    '课程简介': '課程簡介',
    '请录入课程简介!': '請錄入課程簡介!',
    '课程目录': '課程目錄',
    '上传PDF': '上傳PDF',
    '删除PDF': '刪除PDF',
    '试看课程视频': '試看課程視頻',
    '新增充值': '新增充值',
    '新增父类目': '新增父類目',
    '输入消息内容进行检索': '輸入消息內容進行檢索',
    '只显示系统消息': '只顯示系統消息',
    '聊天消息': '聊天消息',
    '系统消息': '系統消息',
    '其它消息': '其它消息',
    '发送者': '發送者',
    '消息内容': '消息內容',
    '消息类型': '消息類型',
    '发送时间': '發送時間',
    '消息详情': '消息詳情',
    '新增单位': '新增單位',
    '单位名称': '單位名稱',
    '事件名称': '事件名稱',
    '发生地点': '發生地點',
    platmanagemtnt: '平臺管理',    
    branchlist: '分店清單',
    fabriclist: '面料商清單',
    myaccount:'資金賬戶',
    designers: '入駐版師清單',
    PLT文件价格: 'PLT文件價格',
    '模板内容': '模板內容',
    '管理员': '管理員',
    '确定要删除当前视频吗?': '確定要刪除當前視頻嗎?',
    '地址': '地址',
    '播放终端': '播放終端',
    '指定位置': '指定位置',
    '升级会员处': '升級會員處',
    '未指定': '未指定',
    '标题:': '標題:',
    '请录入视频标题!': '請錄入視頻標題!',
    '请录入视频标题': '請錄入視頻標題',
    '分类:': '分類:',
    '请选择视频分类!': '請選擇視頻分類!',
    '视频地址:': '視頻地址:',
    '封面图片:': '封面圖片:',
    '播放终端:': '播放終端:',
    '指定位置:': '指定位置:',
    '排序:': '排序:',
    '请录入视频地址或点击浏览上传视频!': '請錄入視頻地址或點擊瀏覽上傳視頻!',
    '请上传视频封面图片!': '請上傳視頻封面圖片!',
    '请选择播放终端!': '請選擇播放終端!',
    '请录入排序值!': '請錄入排序值!',
    '平台客户': '平臺客戶',
    '分店客户': '分店客戶',
    '面料商客户': '面料商客戶',
    '成衣生产商客户': '成衣生產商客戶',
    '新增视频文件': '新增視頻文件',
    '分类名称': '分類名稱',
    '新增分类': '新增分類',
    '新增视频分类': '新增視頻分類',
    '录入分类名称': '錄入分類名稱',
    '用户名密码登录': '用戶名密碼登錄',
    '用户名/手机号码': '用戶名/手機號碼',
    '密码': '密碼',
    '记住账号': '記住賬號',
    '忘记密码': '忘記密碼',
    '登录': '登錄',
    '手机验证码登录': '手機驗證碼登錄',
    '输入手机号码': '輸入手機號碼',
    '输入验证码': '輸入驗證碼',
    '微信扫码登录': '微信掃碼登錄',
    '绑定手机号': '綁定手機號',
    '请录入11位手机号码': '請錄入11位手機號碼',
    '请录入手机号码': '請錄入手機號碼',
    '请录入6位短信验证码': '請錄入6位短信驗證碼',
    '店面未激活，请等待激活后再登录！': '店面未激活，請等待激活後再登錄！',
    '店面已关闭，如需开通，请联系管理员处理！': '店面已關閉，如需開通，請聯繫管理員處理！',
    '店面已锁定，请联系管理员处理！': '店面已鎖定，請聯繫管理員處理！',
    '绑定成功,并自动完成登录。': '綁定成功,並自動完成登錄。',
    '请输入正确的验证码': '請輸入正確的驗證碼',
    '请输入正确的手机号': '請輸入正確的手機號',
    '获取验证码失败': '獲取驗證碼失敗',
    '手机号码未注册': '手機號碼未註冊',
    '请录入正确的手机号码！': '請錄入正確的手機號碼！',
    '输入参数名称开始检索': '輸入參數名稱開始檢索',
    '参数名称': '參數名稱',
    '参数说明': '參數說明',
    '参数值': '參數值',
    '最后修改时间': '最後修改時間',
    '制版师回复使用模板': '製版師回覆使用模板',
    '客户回复使用模板': '客戶回覆使用模板',
    '开通线下支付': '開通線下支付',
    '开通支付宝支付': '開通支付寶支付',
    '件': '件',
    '折': '折',
    '点击查看发货人': '點擊查看發貨人',
    '点击查看模板内容': '點擊查看模板內容',
    '点击查看/编辑账号信息': '點擊查看/編輯賬號信息',
    '例：四川省成都市清羊区成明路423号': '例：四川省成都市清羊區成明路423號',
    '例：张三': '例：張三',
    '例：18930888888': '例：18930888888',
    '编辑收款账号信息': '編輯收款賬號信息',
    '开户名称:': '開戶名稱:',
    '请录入开户名称!': '請錄入開戶名稱!',
    '银行地址:': '銀行地址:',
    '请录入开户银行!': '請錄入開戶銀行!',
    '开户账号:': '開戶賬號:',
    '请录入开户账号!': '請錄入開戶賬號!',
    '短信验证:': '短信驗證:',
    '请录入验证码!': '請錄入驗證碼!',
    '发送验证码': '發送驗證碼',
    '发送至': '發送至',
    '验证码不正确': '驗證碼不正確',
    '资产信息': '資產信息',
    '可提现额度：': '可提現額度：',
    '账户总额度：': '賬戶總額度：',
    '今日入账-￥': '今日入賬-￥',
    '不可提现': '不可提現',
    '未提现': '未提現',
    '历史入账-￥': '歷史入賬-￥',
    '入账时间：': '入賬時間：',
    '已收款': '已收款',
    '历史提现': '歷史提現',
    '收款信息': '收款信息',
    '开户行:': '開戶行:',
    '请录入银行名称如：中国银行!': '請錄入銀行名稱如：中國銀行!',
    '请录入银行名称如：中国银行': '請錄入銀行名稱如：中國銀行',
    '账号名称:': '賬號名稱:',
    '请录入持卡人名称!': '請錄入持卡人名稱!',
    '请录入持卡人名称': '請錄入持卡人名稱',
    '银行卡号:': '銀行卡號:',
    '请录入银行卡号!': '請錄入銀行卡號!',
    '请录入银行卡号': '請錄入銀行卡號',
    '可提现额度': '可提現額度',
    '提现金额必须大于0': '提現金額必須大於0',
    '提现申请成功': '提現申請成功',
    '还没有设置提现账号，请先设置提款账号后再提现。': '還沒有設置提現賬號，請先設置提款賬號後再提現。',
    '订单客户': '訂單客戶',
    '入账原由': '入賬原由',
    '收退款': '收退款',
    '提现完结时间': '提現完結時間',
    '发货人信息': '發貨人信息',
    '发货人姓名:': '發貨人姓名:',
    '请录入发货人姓名!': '請錄入發貨人姓名!',
    '发货人电话:': '發貨人電話:',
    '请录入发货人电话!': '請錄入發貨人電話!',
    '公司名称:': '公司名稱:',
    '请录入公司名称!': '請錄入公司名稱!',
    '发货地邮编:': '發貨地郵編:',
    '请录入发货地邮编!': '請錄入發貨地郵編!',
    '发货地省:': '發貨地省:',
    '请录入发货地省!': '請錄入發貨地省!',
    '发货地市:': '發貨地市:',
    '请录入发货地市!': '請錄入發貨地市!',
    '发货地县:': '發貨地縣:',
    '请录入发货地县!': '請錄入發貨地縣!',
    '详细地址:': '詳細地址:',
    '请录入详细地址!': '請錄入詳細地址!',
    '当前您的帐号未绑定手机号为了保障您的权益,': '當前您的帳號未綁定手機號為了保障您的權益,',
    '请务必绑定手机号': '請務必綁定手機號',
    '输入视频标题检索': '輸入視頻標題檢索',
  },
}
